import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function LoaderRow(props: Props) {
  return (
    <div className={styles.row}>
      <div className={styles.resourceCell}>
        <div className={styles.chevronBox} />
        <Skeleton className={styles.avatar} />
        <div className={styles.identity}>
          <Skeleton className={styles.name} />
          <Skeleton className={styles.profession} />
        </div>
      </div>
      {Array.from({ length: props.columns }, (_, index) => (
        <div key={index} className={styles.cell}>
          <Skeleton className={styles.cellBar} />
        </div>
      ))}
    </div>
  );
}

export { LoaderRow };
